<template>
    <OverlayLoader :isLoading="!staffleOptionsLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('clients.company')"
                />

                <MyCompanyMenu></MyCompanyMenu>

                <AccountSubscriptionInformation ref="accountInfo"></AccountSubscriptionInformation>

                <UpcomingSubscriptionInformation v-if='upcomingSubscriptionLoaded' :subscription='upcomingSubscription' @cancelUpcomingSubscription='cancelUpcomingSubscription'></UpcomingSubscriptionInformation>

                <Alert v-if='hasUnpaidCustomSubscriptions' type='custom-subscription'>{{ t('alert.subscriptions.has_custom_subscription_options') }}</Alert>

                <div v-if='!upcomingSubscription'>
                    <form @submit.prevent="submitForm" method="POST">
                        <h4>{{ t('clients.company.subscription.plan') }}</h4>
                        <div class="subscription" >
                            <SubscriptionPlan
                                :disabled="user.client.subscription"
                                :sub="subscription"
                                :type="'free'"
                                :imgIcon="'fa-heart'"
                                :color="'pink'"
                                @setActiveSub="changeActiveSub"
                            ></SubscriptionPlan>
                            <SubscriptionPlan
                                :sub="subscription"
                                :type="'once'"
                                :imgIcon="'fa-peace'"
                                :color="'green'"
                                @setActiveSub="changeActiveSub"
                                :options="staffleOptions"
                                :disabled="false"
                                :paymentIntervalOptions="['once']"
                                :requestedAmount="requestedAmount"
                                @setPaymentInterval="paymentInterval = $event"
                                @changeRequestedAmount="requestedAmount = $event"
                            ></SubscriptionPlan>
                            <SubscriptionPlan
                                :sub="subscription"
                                :type="'yearly'"
                                :imgIcon="'fa-gem'"
                                :color="'yellow'"
                                @setActiveSub="changeActiveSub"
                                :options="staffleOptions"
                                :disabled="false"
                                :paymentIntervalOptions="['month', 'year']"
                                :requestedAmount="requestedAmount"
                                @setPaymentInterval="setPaymentInterval"
                                @changeRequestedAmount="requestedAmount = $event"
                            ></SubscriptionPlan>
                            <!-- <SubscriptionPlan
                                :sub="subscription"
                                :type="'Once'"
                                :imgIcon="'fa-peace'"
                                :color="'green'"
                                @setActiveSub="changeActiveSub"
                                :options="staffleOptions"
                            ></SubscriptionPlan>
                            <SubscriptionPlan
                                :sub="subscription"
                                :type="'Yearly'"
                                :imgIcon="'fa-gem'"
                                :color="'yellow'"
                                @setActiveSub="changeActiveSub"
                                :options="staffleOptions"
                            ></SubscriptionPlan> -->
                        </div>

                        <FormSubmit
                            v-if="subscription.subtype !== 'request'"
                            :buttonLabel="submittingIsLoading ? $translate.text('general.loading') :  $translate.text('general.continue_to_payment')"
                            :disabled="submittingIsLoading"
                        />
                        <FormSubmit
                            v-if="subscription.subtype === 'request'"
                            :buttonLabel="submittingIsLoading ? $translate.text('general.loading') :  $translate.text('general.continue_with_request')"
                            :disabled="submittingIsLoading"
                        />
                    </form>
                </div>
            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import CustomStorage from '@glenngijsberts/customstorage';

import PageHeader from '@/components/PageHeader/PageHeader';
import FormSubmit from '@/components/Forms/FormSubmit';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import MyCompanyMenu from '@/components/MyCompanyMenu/MyCompanyMenu';
import SubscriptionPlan from '@/components/Subscription/SubscriptionPlan';

import { getUser } from '@/helpers/auth';

import { get, post, put, remove } from '@/helpers/http';
import handleError from '@/helpers/error';
import Alert from '@/components/Alert/Alert.vue';
import AccountSubscriptionInformation from '@/components/Account/AccountSubscriptionInformation.vue';
import UpcomingSubscriptionInformation from '@/components/Account/UpcomingSubscriptionInformation.vue';
import swal from 'sweetalert';

// import swal from 'sweetalert';

export default {
    name: 'MyCompany',

    components: {
        AccountSubscriptionInformation,
        UpcomingSubscriptionInformation,
        Alert,
        MyCompanyMenu,
        PageHeader,
        FormSubmit,
        OverlayLoader,
        SubscriptionPlan,
    },

    data() {
        return {
            staffleOptions: {
                free: [],
                once: [],
                yearly: [],
                yearly_once: [],
            },
            staffleOptionsLoaded: false,
            submittingIsLoading: false,
            subscription: {
                id: 1,
                type: 'free',
                subtype: 'fixed',
            },
            user: [],
            paymentInterval: 'month',
            requestedAmount: 15000,

            upcomingSubscription: null,
            upcomingSubscriptionLoaded: false,
        };
    },

    computed: {
        hasCustomSubscriptions() {
            return this.staffleOptions.once.filter(option => option.custom_subscription).length > 0 ||
                this.staffleOptions.yearly.filter(option => option.custom_subscription).length > 0 ||
                this.staffleOptions.yearly_once.filter(option => option.custom_subscription).length > 0;
        },

        hasUnpaidCustomSubscriptions() {
            return this.staffleOptions.once.filter(option => option.custom_subscription && option.id !== this.subscription.id).length > 0 ||
                this.staffleOptions.yearly.filter(option => option.custom_subscription && option.id !== this.subscription.id).length > 0 ||
                this.staffleOptions.yearly_once.filter(option => option.custom_subscription && option.id !== this.subscription.id).length > 0;
        },
    },

    created() {
        this.getStaffleOptions();
        this.user = getUser();
        this.getSubscription();
        this.getUpcomingSubscription();
    },

    methods: {
        setPaymentInterval(value) {
            this.paymentInterval = value
        },
        changeActiveSub($event, option, subtype) {
            this.subscription.type = $event;
            this.subscription.subtype = subtype;
            this.subscription.id = option;
        },

        getSubscription() {
            const user = getUser();
            if (user.client.subscription === null) {
                this.subscription.type = 'free';
                this.subscription.id = 1;
            } else {
                this.subscription.type = user.client.subscription.type.type;
                this.subscription.id = user.client.subscription.type.id;
            }
        },

        getUpcomingSubscription() {
            this.upcomingSubscriptionLoaded = false;

            get({
                url: `${this.$API_URL}/api/clients/subscriptions/upcoming`,
            })
                .then((response) => {
                    this.upcomingSubscription = response.data.data;

                    this.upcomingSubscriptionLoaded = true;
                });
        },

        cancelUpcomingSubscription() {
            swal(
                this.$translate.text('alert.confirm.cancel_upcoming_payment'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    remove({
                        url: `${this.$API_URL}/api/clients/subscriptions/upcoming`,
                    })
                        .then(() => {
                            this.subscription = null;

                            swal({
                                title: this.$translate.text('alert.title.succes'),
                                text: this.$translate.text('alert.subscriptions.upcoming_canceled'),
                            });

                            this.getLastPayment();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },

        getStaffleOptions() {
            get({
                url: `${this.$API_URL}/api/options`,
            })
                .then((response) => {
                    const options = response.data.data;
                    options.forEach(item => {
                        if (item.type === 'once') {
                            this.staffleOptions.once.push(item);
                        } else if (item.type === 'yearly') {
                            this.staffleOptions.yearly.push(item);

                            const new_item = Object.assign({}, item);
                            new_item.price = Math.round((new_item.price * 12) * 0.95);

                            this.staffleOptions.yearly_once.push(new_item);
                        }
                    });

                    // this.staffleOptions = response.data.data;
                    this.staffleOptionsLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        getLastPayment() {
            get({
                url: `${this.$API_URL}/api/clients/subscriptions`,
            })
                .then((response) => {
                    const auth = CustomStorage.get('auth');
                    auth.user.client.subscription = response.data.data;
                    CustomStorage.set('auth', auth, 60);

                    this.subscription = response.data.data.type;

                    this.$refs.accountInfo.getAccountInfo();
                    this.getUpcomingSubscription();
                });
        },

        submitForm() {
            this.submittingIsLoading = true;
            if (this.user.client.subscription === null) {
                post({
                    url: `${this.$API_URL}/api/clients/subscriptions`,
                    data: {
                        option_id: this.subscription.id,
                        client_id: this.user.client.id,
                        payment_interval: this.paymentInterval,
                        requested_amount: this.requestedAmount,
                    },
                })
                    .then((response) => {
                        // free option
                        if (response.data.data.checkout_url === null) {
                            if (this.subscription.subtype === 'request') {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.subscriptions.custom_subscription_requested'),
                                });
                            } else if (response.data.data.scheduled_at !== null) {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.subscriptions.subscription_scheduled').replace('%scheduled_at%', response.data.data.scheduled_at_formatted),
                                });
                            } else {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.success.message.subscribed'),
                                });
                            }

                            this.getLastPayment();

                            this.submittingIsLoading = false;
                        } else {
                            window.location.href = response.data.data.checkout_url;
                            this.submittingIsLoading = false;
                        }
                    })
                    .catch((error) => {
                        this.submittingIsLoading = false;
                        // this.getLastPayment();
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            } else {
                put({
                    url: `${this.$API_URL}/api/clients/subscriptions`,
                    data: {
                        option_id: this.subscription.id,
                        payment_interval: this.paymentInterval,
                        requested_amount: this.requestedAmount,
                    },
                })
                    .then((response) => {
                        // free option
                        if (response.data.data.checkout_url === null) {
                            if (this.subscription.subtype === 'request') {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.subscriptions.custom_subscription_requested'),
                                });
                            } else if (response.data.data.scheduled_at !== null) {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.subscriptions.subscription_scheduled').replace('%scheduled_at%', response.data.data.scheduled_at_formatted),
                                });
                            } else {
                                swal({
                                    title: this.$translate.text('alert.title.succes'),
                                    text: this.$translate.text('alert.success.message.subscribed'),
                                });
                            }

                            this.getLastPayment();

                            this.submittingIsLoading = false;
                        } else {
                            window.location.href = response.data.data.checkout_url;
                            this.submittingIsLoading = false;
                        }
                    })
                    .catch((error) => {
                        this.submittingIsLoading = false;
                        // this.getLastPayment();
                        handleError({
                            error,
                            message: this.$translate.text('alert.whoops'),
                        });
                    });
            }

            // put({
            //     url: `${this.$API_URL}/api/clients/subscriptions/${this.user.client.id}`,
            //     data: {
            //         type: this.subscription.type,
            //         price: this.subscription.option,
            //     },
            // })
            //     .then(() => {
            //         this.submittingIsLoading = false;
            //         swal({
            //             title: this.$translate.text('alert.success'),
            //             text: this.$translate.text('alert.success.message.saved'),
            //         });
            //     })
            //     .catch((error) => {
            //         this.submittingIsLoading = false;

            //         handleError({
            //             error,
            //             message: this.$translate.text('alert.whoops'),
            //         });
            //     });
        },
    },
};
</script>
<style lang="scss" scoped>
.alert {
    margin-bottom: 0;
}

form {
    padding-top: 24px;
}

.subscription {
    list-style: none;
    list-style-type: none;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    margin: 0;
}
</style>
